"use client";

import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";

import { cn } from "../../lib/utils";

const Vector = () => {
  return (
    <svg
      width="24"
      height="107"
      viewBox="0 0 24 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0768 65.4419C15.6106 53.0191 24 43.4348 24 34.7679C24 28.2402 20.1339 18.3947 15.9457 7.41963C14.755 4.78735 13.7215 -0.115777 11.9991 0.00208701C10.2766 -0.115777 9.24315 4.78735 8.05242 7.41963C3.86614 18.3947 0 28.2402 0 34.7679C0 43.4348 8.39129 53.0191 7.92324 65.4419C8.75451 76.3757 4.14697 85.9658 3.25018 94.1456C2.96747 102.614 7.06576 107.014 11.9991 106.961C16.9342 107.014 21.0325 102.614 20.748 94.1456C19.8512 85.9658 15.2436 76.3757 16.0749 65.4419H16.0768Z"
        fill="#CE0A2C"
      />
    </svg>
  );
};

function Slider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  const _values = React.useMemo(
    () =>
      Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
        ? defaultValue
        : [min, max],
    [value, defaultValue, min, max]
  );

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(
        "relative flex w-full h-[12px] touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col bg-[#F5F5F5] rounded-[2px]",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className={cn(
          "bg-muted relative grow overflow-hidden rounded-[2px] data-[orientation=horizontal]:h-[12px] data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
        )}
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className={cn(
            "bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
          )}
        />
      </SliderPrimitive.Track>
      {Array.from({ length: _values.length }, (_, index) => (
        <SliderPrimitive.Thumb
          data-slot="slider-thumb"
          key={index}
          className="block shrink-0 transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 relative"
        >
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <Vector />
          </div>
        </SliderPrimitive.Thumb>
      ))}
    </SliderPrimitive.Root>
  );
}

export { Slider };
